import { render, staticRenderFns } from "./SvgImage.vue?vue&type=template&id=4446d95b&"
import script from "./SvgImage.vue?vue&type=script&lang=ts&"
export * from "./SvgImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports